import Button from '../../components/ui/Button/Button.jsx';
import styles from './Success.module.css';

export default function Success() {
  return (
    <section className={styles.section}>
      <div className={`container ${styles.wrap}`}>
        <div className={styles.iconRing}>
          <span className={styles.check}>✓</span>
        </div>
        <h1 className={styles.title}>Message sent</h1>
        <p className={styles.text}>
          Thanks for reaching out. We've received your message and will reply within
          one business day.
        </p>
        <div className={styles.actions}>
          <Button to="/" size="lg">Back to home</Button>
          <Button to="/insights" variant="secondary" size="lg">Read Insights</Button>
        </div>
      </div>
    </section>
  );
}
